import { TeaserProps } from '@design-system/teaser';

import { ctaBlockMapper } from '~/mappers/ctaBlock';
import { headingBlockMapper } from '~/mappers/headingBlock';
import { imageMapper } from '~/mappers/image';

import { Teaser } from './models';

export const teaserMapper = ({
  variant,
  componentId,
  backgroundImage: [backgroundImage],
  heading,
  ctaBlocks: { ctaBlocks },
  disclaimer,
  foregroundImage: [foregroundImage],
  tag,
  mode,
  size,
  width,
  uid,
}: Teaser): TeaserProps =>
  ({
    // TODO - HKX-1311 - replace next line with: id: componentId,
    ...(componentId && { id: componentId }),
    variant,
    backgroundImage: imageMapper(backgroundImage),
    headingBlock: { props: headingBlockMapper(heading) },
    ...(ctaBlocks.length && { ctaBlock: { props: ctaBlockMapper(ctaBlocks) } }),
    ...(disclaimer && { disclaimer }),
    foregroundImage: imageMapper(foregroundImage),
    tag,
    mode,
    ...(size && { size }),
    ...(width && { width }),
    uid,
  } as TeaserProps);
